<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <b>我的笔记</b>
      </div>
    </div>

    <section class="uc-userCenterTitleTab3 bg-white">
      <div class="table">
        <table>
          <tr>
            <th style="width:38%;" class="left">笔记内容</th>
            <th style="width:38%;">课程名称</th>
            <th style="width:24%;">记录时间</th>
          </tr>
          <tr v-if="list.total_count == 0">
            <td colspan="6">
              <div class="content-empty">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
            </td>
          </tr>
          <tr v-for="(item, index) in list.items" :key="index">
            <td class="left">
              {{ item.content }}
            </td>
            <td class="uc-orange">
              <b>{{ item.course_name }}</b>
            </td>
            <td>{{ item.create_time }}</td>
          </tr>
        </table>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'PersonalMyNoteDetail',
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 10,
        courseId: this.$route.params.id,
      },
      list: [],
      formLabelWidth: '100px',
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getNotes();
    },
    async getNotes() {
      const response = await this.$api.course.getMyCourseNotes(this.query);
      this.list = response.data.data;
    },

    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },
  },
};
</script>
